/**
 * 对一个数组取随机下标
 * @param array 数组
 * @param number 取多少个下标
 */
export function getRandomIndexArray(array,number){
    const list = []
    const len = array.length
    for(let i = 0; i < len && i < number; i++){
        let index = null;
        for(;index == null || list.includes(index);){
            // 随机取下标
            index = Math.floor(Math.random() * len);
        }
        list.push(index)
    }
    return list
}

/**
 * 对一个数组随机取值（不会重复取）
 * @param array 数组
 * @param number 取多少个值
 */
export function randomSelect(array,number){
    const indexList = getRandomIndexArray(array,number)
    const list = []
    for(let i = 0; i < indexList.length; i++){
        const index = indexList[i]
        const item = array[index]
        list.push(item)
    }
    return list
}
